/* svnty-rails.js: PEOPLE ALSO VIEWED's settle (item B of Design_Part4, 2026-09-25; sections/svnty-also-viewed.liquid tags
 * this file, so it guards itself and runs once). Trade's <product-recommendations> (global.js) fetches the section from the
 * recommendations route when it nears the viewport and swaps its content in; Liquid has already chosen the cards. This file
 * only watches for the cards to land, then lifts the empty state and levels the pictures (THE ROW LAW); svnty-rail-nav.js
 * wires the arrows by its own observer. RECENTLY VIEWED lives in assets/svnty-taste.js since D4-31 (its old half here was
 * retired in D5-5). */
(function () {
  'use strict';
  window.SVNTY = window.SVNTY || {};
  if (window.SVNTY.rails) return;

  /* the cards are in: show the section and level the pictures */
  function settle(root) {
    root.hidden = false;
    root.removeAttribute('data-svnty-empty');
    try { if (window.SVNTY.rows && typeof window.SVNTY.rows.measure === 'function') window.SVNTY.rows.measure(); } catch (e) {}
  }

  function also(root) {
    if (root.__svntyRail) return;
    root.__svntyRail = true;
    var ready = function () { return !!root.querySelector('.svnty-similar__item'); };
    if (ready()) { settle(root); return; }
    if (typeof MutationObserver !== 'function') return;
    var mo = new MutationObserver(function () { if (ready()) { mo.disconnect(); settle(root); } });
    mo.observe(root, { childList: true });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-svnty-also-viewed]'), also); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* the theme editor re-renders a section in place */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target, a = t && t.querySelector ? t.querySelector('[data-svnty-also-viewed]') : null;
    if (a) also(a);
  });

  window.SVNTY.rails = { also: also };
})();
